import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export type NetworkLayout = '2d' | '3d' | 'classic' | 'artistic'

const VALID_LAYOUTS: NetworkLayout[] = ['2d', '3d', 'classic', 'artistic']

function isValidLayout(value: string | null): value is NetworkLayout {
  return VALID_LAYOUTS.includes(value as NetworkLayout)
}

export function useNetworkLayout(): {
  layout: NetworkLayout
  setLayout: (next: NetworkLayout) => void
} {
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get('layout')
  const layout: NetworkLayout = isValidLayout(raw) ? raw : '2d'

  const setLayout = useCallback(
    (next: NetworkLayout) => {
      setSearchParams(
        (prev) => {
          const updated = new URLSearchParams(prev)
          updated.set('layout', next)
          return updated
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { layout, setLayout }
}
